import { frames, icons, useMediaQuery } from "../../Styles/index"
import { useTranslation } from "react-i18next"
import "../../Translations/index"
import { Pages } from "../Routers/CloudPanel/globalMenu_Router"
import { useNavigate } from "react-router-dom"
import { StyleObject } from "styletron-react"
import { useMemo } from "react"

//TODO
import { CoreNavLink } from "../../Components/BaseComponents/coreNavLink"
import { NavLinkTypes } from "../../Definitions/navLinkTypes"

const navItems = [
  { page: Pages.dashboard, icon: icons.dashboard, disabled: true },
  { page: Pages.kpi, icon: icons.kpi },
  { page: Pages.feedCurves, icon: icons.feedCurves },
  { page: Pages.silos, icon: icons.silos, disabled: true },
  { page: Pages.animals, icon: icons.animals },
  { page: Pages.reports, icon: icons.reports },
  { page: Pages.logbook, icon: icons.logBook },
  { page: Pages.globalSettings, icon: icons.globalSettings },
]
interface GlobalMenu_Props {
  overrides?:{
      gridArea?: string
  }
}

export default function GlobalMenu({overrides}:GlobalMenu_Props) {
  const navigator = useNavigate()
  const {t} = useTranslation()
  const groupMenu2columns = useMediaQuery(`(max-width: 454px), (min-width: 1000px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
        {} as StyleObject, //default stlye
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])

  return (
    <frames.GlobalMenu $style={_Root}>
      <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px", display: "flex", 
    flexWrap: "wrap",  
    justifyContent: "start", gap: "5px"}}>
        {navItems.map(({ page, icon, disabled }) => {
          const label = t(`menuHeaders.${page}`, { defaultValue: page })

          return (
            <CoreNavLink
              key={page}
              content={label}
              path={page}
              endPath={false}
              icon={icon}
              navLinkType={NavLinkTypes.globalMenuNavLink}
              disabled={disabled}
            />
          )
        })}
      </div>
    </frames.GlobalMenu>
  )

}